<div *ngIf="player?.is_suspended == 1" class="alert alert-danger" role="alert"><strong>Account suspended.</strong> Top-up, withdrawal and agent actions are unavailable. <button type="button" class="btn btn-outline-danger btn-sm ms-2" (click)="resetPlayer()">New search</button></div>
<fieldset class="border-0 p-0 m-0 w-100" [disabled]="player?.is_suspended == 1" [attr.inert]="player?.is_suspended == 1 ? '' : null">
<!-- Search Player -->
<div class="row" *ngIf="!player_uuid">
    <div class="col-md-6 col-12">
        <div class="page-section">
            <div class="page-section-header">
                <h2 class="page-section-title">Search Player (Wallet Only)</h2>
            </div>
            <div class="page-section-filters">
                <input type="text" class="form-control form-control-sm flex-fill" style="max-width:none;"
                    placeholder="Enter Player Code / Mobile / Name" #search="ngModel" [(ngModel)]="player_search" />
                <button class="btn btn-primary btn-sm" (click)="editPlayer()">+ Player</button>
                <button class="btn btn-outline-primary btn-sm" (click)="getUnknownPayment()">+ Unknown Payment</button>
            </div>
            <div *ngIf="is_searching_player" class="p-3">
                <p class="text-muted mb-0" style="font-style: italic;">Searching Player ...</p>
            </div>
            <div class="page-section-body" *ngIf="!is_searching_player && players.length > 0 && !data.player_uuid">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Code</th>
                            <th>Name</th>
                            <th>Mobile</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let player of players">
                            <td class="align-middle">{{player.code}} <span *ngIf="player.is_suspended == 1" class="badge bg-danger">Suspended</span><span class="ms-2 badge bg-success"
                                    *ngIf="player.is_banker">{{player.is_banker_admin ? 'Banker Admin' :
                                    'Banker'}}</span></td>
                            <td class="align-middle">{{player.name}}</td>
                            <td class="align-middle">{{player.mobile}}</td>
                            <td class="text-end"><button class="btn btn-sm btn-outline-primary"
                                    (click)="selectPlayer(player.uuid)"><small>Select</small></button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<!-- Player Selected -->
<ng-container *ngIf="data.player_uuid">

    <!-- Player Info Bar -->
    <div class="page-section mb-3">
        <div class="page-section-header">
            <div class="d-flex align-items-center gap-2">
                <h2 class="page-section-title mb-0">{{player.name}} | {{player.code}}</h2>
                <button class="btn btn-sm btn-warning" (click)="resetPlayer()">New Search</button>
            </div>
            <div class="page-section-actions">
                <button class="btn btn-sm btn-outline-light" (click)="back()" *ngIf="player_uuid">Back</button>
            </div>
        </div>
        <div class="player-balance-bar">
            <ng-container *ngIf="player.is_banker && !player.is_banker_admin">
                <div class="player-balance-item">
                    <span class="player-balance-label">Banker Wallet</span>
                    <span class="player-balance-value">{{wallet_balance | number : '1.3-3'}}</span>
                </div>
            </ng-container>
            <ng-container *ngIf="!player.is_banker">
                <div class="player-balance-item">
                    <span class="player-balance-label">Wallet</span>
                    <span class="player-balance-value">{{wallet_balance | number : '1.3-3'}}</span>
                </div>
                <div class="player-balance-item">
                    <span class="player-balance-label">Referral</span>
                    <span class="player-balance-value">{{referral_wallet | number : '1.3-3'}}</span>
                </div>
                <div class="player-balance-item">
                    <span class="player-balance-label">Agent</span>
                    <span class="player-balance-value">{{agent_wallet | number : '1.3-3'}}</span>
                </div>
            </ng-container>
        </div>
        <div class="page-section-filters player-menu-bar">
            <ng-container *ngIf="!player.is_banker">
                <!-- common-usage line: always-on Topup / Withdraw, fixed above Customize -->
                <div class="player-menu-grid player-menu-common" *ngIf="commonPlayerMenu.length">
                    <a class="player-menu-btn player-menu-btn-common" href="javascript:void(0)"
                        *ngFor="let item of commonPlayerMenu; trackBy: trackMenu"
                        (click)="item.run()">
                        <i class="fa {{item.icon}}"></i><span>{{item.label}}</span>
                    </a>
                </div>
                <!-- favourites toolbar: pin actions / expand collapsed menu -->
                <div class="player-menu-toolbar">
                    <button type="button" class="player-menu-tool" [class.active]="menuCustomize"
                        (click)="toggleMenuCustomize()">
                        <i class="fa fa-star"></i> {{ menuCustomize ? 'Done' : 'Customize' }}
                    </button>
                    <button type="button" class="player-menu-tool" *ngIf="hasMenuFavorites && !menuCustomize"
                        (click)="toggleShowAllMenu()">
                        <i class="fa" [ngClass]="showAllMenu ? 'fa-chevron-up' : 'fa-ellipsis-h'"></i>
                        {{ showAllMenu ? 'Less' : 'More' }}
                    </button>
                    <span class="player-menu-hint" *ngIf="menuCustomize">Tap an action to pin / unpin it</span>
                </div>
                <div class="player-menu-grid">
                    <a class="player-menu-btn" href="javascript:void(0)"
                        *ngFor="let item of visiblePlayerMenu; trackBy: trackMenu"
                        [class.is-fav]="isMenuFav(item.key)" [class.customizing]="menuCustomize"
                        (click)="menuCustomize ? toggleMenuFav(item, $event) : runMenu(item)">
                        <i class="fav-star fa fa-star" *ngIf="menuCustomize || isMenuFav(item.key)"
                            [class.on]="isMenuFav(item.key)"></i>
                        <i class="fa {{item.icon}}"></i><span>{{item.label}}</span>
                    </a>
                </div>
                <div class="player-menu-empty" *ngIf="!visiblePlayerMenu.length && !menuCustomize">
                    No favourites pinned yet — click <b>Customize</b> to choose your most-used actions.
                </div>
            </ng-container>
            <div class="player-menu-grid" *ngIf="player.is_banker">
                <a class="player-menu-btn" href="javascript:void(0)" (click)="editPlayer(player)">
                    <i class="fa fa-user"></i><span>Profile</span></a>
                <a class="player-menu-btn" href="javascript:void(0)" (click)="bankerWallet()" *ngIf="!player.is_banker_admin">
                    <i class="fa fa-wallet"></i><span>Banker Wallet</span></a>
                <a class="player-menu-btn" href="javascript:void(0)" (click)="loginAccount()" *ngIf="current_company.domain">
                    <i class="fa fa-sign-in"></i><span>Login</span></a>
            </div>
        </div>
    </div>

    <!-- Bank Summary + Transaction History -->
    <div class="row mb-3">
        <div class="col-md-3 col-12 mb-3 mb-md-0">
            <div class="page-section mb-0">
                <div class="page-section-header">
                    <h2 class="page-section-title">Bank Summary</h2>
                </div>
                <div class="page-section-body">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Bank Name</th>
                                <th class="text-end">Balance</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let bank of banks">
                                <th>{{bank.title}}</th>
                                <td class="text-end">{{bank.balance | number : '1.2-2'}}</td>
                            </tr>
                        </tbody>
                        <tfoot *ngIf="is_loading_bank">
                            <tr>
                                <th colspan="2">Loading</th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-md-9 col-12">
            <app-player-transaction-history [all]="true" [setPlaterUUID]="data.player_uuid" [setHistoryType]="'wallet'"
                [is_agent]="player?.is_agent" [is_banker]="player?.is_banker"
                [visible_tabs]="['bank', 'game', 'wallet', 'agent', 'referral', 'banker', 'promotion', 'other']"
                #th></app-player-transaction-history>
        </div>
    </div>

</ng-container>

</fieldset>
